import { createRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';

import { AppErrorPage, AppNotFoundPage } from './components/site/error-page';
import * as TanstackQuery from './integrations/tanstack-query/root-provider';
import { routeTree } from './routeTree.gen';

export function getRouter() {
    const rqContext = TanstackQuery.getContext();

    const router = createRouter({
        routeTree,
        context: { ...rqContext },
        defaultPreload: 'intent',
        // Keep the previous screen until the next route is ready. The default
        // 1s pendingMs + 500ms pendingMinMs otherwise blanks the outlet
        // (full-screen flash) when a stale loader, like home, takes >1s.
        defaultPendingMs: Number.POSITIVE_INFINITY,
        defaultPendingMinMs: 0,
        defaultErrorComponent: AppErrorPage,
        defaultNotFoundComponent: AppNotFoundPage,
        scrollRestoration: true,
        scrollRestorationBehavior: 'instant',
        // Admin console scrolls inside [data-scroll-container].
        scrollToTopSelectors: ['html', 'body', '[data-scroll-container]'],
        Wrap: ({ children }: { children: React.ReactNode }) => (
            <TanstackQuery.Provider queryClient={rqContext.queryClient}>
                {children}
            </TanstackQuery.Provider>
        ),
    });

    setupRouterSsrQueryIntegration({
        router,
        queryClient: rqContext.queryClient,
    });

    return router;
}

declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}
